<template>
    <div class="map-wrapper">
        <div class="res-content-wrapper">
            <ion-grid class="loc-search">
                <ion-row>
                    <ion-col size-md="11" size-xs="12">
                        <div class="loc-wrpaper">
                            <span class="rp-desktop">Location:</span>
                            <span class="rp-mobile"><img src="/assets/images/common/search/116836@2x.png" class="lense-icon"/></span>
                            <input type="text" id="pac-input" v-model="locationAdd" placeholder="Enter Location" />
                            <img src="../../assets/locate.svg" class="map-marker-icon" v-on:click="config">
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div id="res-map"></div>
        <div class="card-list-wrapper">
            <div class="card-list" v-if="cardType === true">
                <ion-grid>
                    <ion-row>
                        <ion-col size-md="6" size-xs="12">
                            <div class="card-list-content">
                                <p class="ion-no-margin title">{{selectedMarker.name}}
                                </p>
                                <p class="ion-no-margin loc">{{selectedMarker.address.line1}},
                                    {{selectedMarker.address.city}}, {{selectedMarker.address.state.name}}</p>
                            </div>
                        </ion-col>
                        <ion-col size-md="6" size-xs="12">
                            <div class="card-list-booking">
                                <div class="call-options">
                                   
                                    <ion-button class="book-btn" v-if="stationMarkerStatus == 'deactivedstation'"
                                        disabled @click="bookNow()" expand="block" shape="round">Next</ion-button>
                                    <ion-button class="book-btn" v-if="stationMarkerStatus != 'deactivedstation'"
                                        @click="bookNow()" expand="block" shape="round">Next</ion-button>
                                </div>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </div>
        <div class="map-overlay" v-if="mapClickFlag"></div>
        <div class="spinnerWrapper">
                <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { IonGrid, IonRow, IonCol, IonFab, IonFabButton, IonSpinner, IonButton, IonIcon } from "@ionic/vue";
import { QrcodeStream } from "vue-qrcode-reader";
import { defineComponent } from "vue";
import { Coordiate } from '@/entity/location/corodinate';
import { EVCStationService } from "@/service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
import { ConfigurationService } from "../../service/configuration";
import { ToastUtils } from "../../util/toast-utils";
// import { error } from 'winston';
// import TagIdScannerModal from "./TagIdScannerModal.vue";
import userData from "../../../public/assets/data/data.json";

export default defineComponent ({
    name: 'CarterGoogleMap',
    components: {
        IonGrid, 
        IonRow, 
        IonCol, 
        IonFab, 
        IonFabButton, 
        IonSpinner, 
        IonButton,
        IonIcon,
        QrcodeStream
    },
    data() {
        return {
            map: null,
            locationAdd: "",
            image: '159615-1.png',
            iconBase: null,
            icons: null,
            currentLoc: {},
            teleUrl: "",
            opensAt: "",
            closesAt: "",
            cardType: false,
            selectedMarker: [],
            markerCoordinates: [],
            selectedMarkerDistance: "",
            selectedObjValue: {},
            markerArray: null,               
            mapClickFlag:false,
            loaderTab:false,
            configData: null,
            isShowingCamera: false,
            chargeNow: false
        }
    },
    mounted() {
        this.iconBase = '/assets/images/reservation/';

        this.icons = {
            deactivedstation: {
                icon: this.iconBase + '159615-1.png'
            },
            activestation: {
                icon: this.iconBase + '159615.png'
            },
            current: {
                icon: this.iconBase + '75689.png'
            },
            selectedMarker: {
                icon: this.iconBase + 'mark.png'
            }, 
            thirsdPartyStation: {
                icon: this.iconBase + '159615_01.png'
            },
            thirdPartyselectedMarker: {
                icon: this.iconBase + 'ThirdPartymark.png'
            },
            available : {
                icon: this.iconBase + '159615_av.png'
            },
            occupied : {
                icon: this.iconBase + '159615_oc.png'
            },
            unreachable: {
                icon: this.iconBase + '159615_unrh.png'
            },
            unavailable : {
                icon: this.iconBase + '159615_unav.png'
            },
            faulted : {
                icon: this.iconBase + '159615_flt.png'
            },
            availableSelectedMarker: {
                icon: this.iconBase + 'mark_av.png'
            }, 
            occupiedSelectedMarker: {
                icon: this.iconBase + 'mark_oc.png'
            }, 
            unreachableSelectedMarker: {
                icon: this.iconBase + 'mark_unrh.png'
            }, 
            unavailableSelectedMarker: {
                icon: this.iconBase + 'mark_unav.png'
            }, 
            faultedSelectedMarker: {
                icon: this.iconBase + 'mark_flt.png'
            }, 
        };
        const element = document.getElementById('res-map');

        var myStyles =[
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];

        const options = {
            zoom: 15,
            styles: myStyles,
            mapTypeControl: false,
            draggable: true,
            scaleControl: false,
            scrollwheel: true,
            navigationControl: false, 
            streetViewControl: false,
            zoomControl: true,
            zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
            },
            fullscreenControl: false,
            chargerTypesSelectedValue: null,
            chargerOutputSelectedValue: null,
            chargerPortSelectedValue: null,
            center: { lat: -34.397, lng: 150.644 }
        }
        this.map = new google.maps.Map(element, options);

        var input = document.getElementById('pac-input');
        this.autoCompleteFormation(input, this)
        this.config()
    },    
    methods: {
        autoCompleteFormation(input, thisValue) {
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', this.map);
            autocomplete.setFields(
                ['address_components', 'geometry', 'icon', 'name']);

            autocomplete.addListener('place_changed', function () {
                thisValue.deleteMarkers()
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    window.alert("No details available for input: '" + place.name + "'");
                    return;
                }
                thisValue.currentLoc = {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng(),
                    type: 'current'
                };
                localStorage.setItem("currentLoc", JSON.stringify(thisValue.currentLoc))
                localStorage.setItem("Autocomplete", input.value)
                this.locationAdd = input.value;
                thisValue.map.setCenter(place.geometry.location);
                thisValue.map.setZoom(thisValue.configData.googleMapZoomLevel)
                thisValue.filterCall()
            });
        },
        async config() {
            this.configData = {"googleMapZoomLevel":13,"stationSearchRadius":10}
            this.getLocation()
        },
        getLocation() {
            this.deleteMarkers()
            var geocoder = new google.maps.Geocoder();
            var activeInfoWindow = null
            var infowindow = new google.maps.InfoWindow();
            this.map.addListener('click', (e) => {
                if (activeInfoWindow) {
                    activeInfoWindow.close();
                }
                activeInfoWindow = infowindow
                this.placeMarkerAndPanTo(e.latLng)
                this.cardType = false;
            });
            var thiscurrentLoc = JSON.parse(localStorage.getItem("currentLoc"));
            var thislocationAdd = localStorage.getItem("Autocomplete");
            if (thiscurrentLoc && thislocationAdd) {
                this.mapViegetLocation();
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    this.currentLoc = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        type: 'current'
                    };
                    localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc));
                    geocoder.geocode({ 'location': pos }, (results, status) => {
                        this.locationAdd = results[0].formatted_address;
                        localStorage.setItem("Autocomplete", this.locationAdd);
                    });
                    this.map.setCenter(pos);
                    this.map.setZoom(this.configData.googleMapZoomLevel)
                    // this.addMarker();
                    this.filterCall()
                    },(error) => {
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                console.log("User denied the request for Geolocation.")
                                break;
                            case error.POSITION_UNAVAILABLE:
                                console.log("Location information is unavailable.")
                                break;
                            case error.TIMEOUT:
                                console.log("The request to get user location timed out.")
                                break;
                            case error.UNKNOWN_ERROR:
                                console.log("An unknown error occurred.")
                                break;
                        }
                    });
                }
            }
        },
        placeMarkerAndPanTo(latLng) {   
            this.mapClickFlag =true;    
            this.loaderTab =true; 
            var geocoder = new google.maps.Geocoder();
            this.deleteMarkers()
            this.currentLoc = {
                latitude: latLng.lat(),
                longitude: latLng.lng(),
                type: 'current'
            };                
            navigator.geolocation.getCurrentPosition((position) => {
                var pos = {
                    lat: this.currentLoc.latitude,
                    lng: this.currentLoc.longitude
                };
                geocoder.geocode({ 'location': pos }, (results, status) => {
                    this.locationAdd = results[0].formatted_address;
                    localStorage.setItem("Autocomplete", this.locationAdd);
                });
            });
            localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc))
            this.filterCall()
        },
        filterCall() {
            this.serviceCall()
        },
        serviceCall() {
            this.markerCoordinates = [];
            this.masterData = userData.stationInfo;
            this.locationDataFormation();
        },
        locationDataFormation() {
            this.masterData.forEach((data) => {
                // var stationStatus = (data.status.id == "A") ? "activestation" : "deactivedstation";
                var stationStatus = "";
                if(data.thirdPartyStatus.id == "Y") {
                    stationStatus = "thirsdPartyStation";
                } else {
                    if(data.status.id == "AV") {
                        stationStatus = "available";
                    } else if(data.status.id == "OC") {
                        stationStatus = "occupied";
                    } else if(data.status.id == "UNRH") {
                        stationStatus = "unreachable";
                    } else if(data.status.id == "UNAV") {
                        stationStatus = "unavailable";
                    } else if(data.status.id == "FLT") {
                        stationStatus = "faulted";
                    } 
                    else {
                        stationStatus = (data.status.id == "A") ? "activestation" : "deactivedstation";
                    }
                    // stationStatus = (data.status.id == "A") ? "activestation" : "deactivedstation";
                }
                
                let locationObj = {
                    latitude: data.coordinate.latitude,
                    longitude: data.coordinate.longitude,
                    type: stationStatus,
                    id: data.id
                }
                this.markerCoordinates.push(locationObj);
                // console.log(this.markerCoordinates)
            })
            this.addMarker();
        },
        addMarker() {
            this.markerCoordinates.push(this.currentLoc);
            const markerMasterData = this.masterData
            this.markerArray = []
            this.markerCoordinates.forEach((coord) => {
                const position = new google.maps.LatLng(coord.latitude, coord.longitude);
                // const marker = new google.maps.Marker({
                const marker = new google.maps.Marker({
                    position,
                    map: this.map,
                    icon: this.icons[coord.type].icon,
                    id: coord.id,
                    iconType: coord.type
                });
                this.markerArray.push(marker)
                if (coord.type != "current") {
                    marker.addListener('click', () => {
                        this.locationAdd = localStorage.getItem("Autocomplete");
                        this.$nextTick(function () {
                            this.cardType = true;

                            var selectedMarker = markerMasterData.filter((data) => {
                                return data.id === marker.id;
                            });
                            this.selectedObjValue = selectedMarker;
                            for (var i = 0; i < this.markerArray.length; i++) {
                                this.markerArray[i].setIcon(this.icons[this.markerArray[i].iconType].icon); // set back to default
                            }
                            // Below code is commented by vinoth on 25.05.2023 as per thirdPartyStation request
                            // marker.setIcon(this.icons["selectedMarker"].icon);
                            if(selectedMarker[0].thirdPartyStatus.id == 'N') {
                                if(selectedMarker[0].status.id == "AV") {
                                    marker.setIcon(this.icons["availableSelectedMarker"].icon);
                                } else if(selectedMarker[0].status.id == "OC") {
                                    marker.setIcon(this.icons["occupiedSelectedMarker"].icon);
                                } else if(selectedMarker[0].status.id == "UNRH") {
                                    marker.setIcon(this.icons["unreachableSelectedMarker"].icon);
                                } else if(selectedMarker[0].status.id == "UNAV") {
                                    marker.setIcon(this.icons["unavailableSelectedMarker"].icon);
                                }else if(selectedMarker[0].status.id == "FLT") {
                                    marker.setIcon(this.icons["faultedSelectedMarker"].icon);
                                } else {
                                    marker.setIcon(this.icons["selectedMarker"].icon);
                                }
                            } else {
                                marker.setIcon(this.icons["thirdPartyselectedMarker"].icon);
                            }
                            
                            // var hoursOfOperations = selectedMarker[0].hoursOfOperations
                            // this.selectedMarkerDistance = selectedMarker[0].distance.description
                            var d = new Date();
                            var n = d.getDay()
                            if (d.getDay() == 0) {
                                n = 6;
                            } else if (d.getDay() == 1) {
                                n = 0;
                            } else {
                                n = n - 1
                            }
                            // var selectedDate = hoursOfOperations[n];
                            // this.opensAt = selectedDate.opensAt
                            // this.closesAt = selectedDate.closesAt
                            this.selectedMarker = selectedMarker[0];
                            this.teleUrl = "tel:" + this.selectedMarker.mobile;
                            this.stationMarkerStatus = marker.iconType
                        })
                    });
                }                    
            });
            this.mapClickFlag =false;
            this.loaderTab =false;
        },
        deleteMarkers() {
            this.clearMarkers();
            this.markerArray = [];
        },
        setMapOnAll(map) {
            if (this.markerArray != null) {
                for (var i = 0; i < this.markerArray.length; i++) {
                    this.markerArray[i].setMap(map);
                }
            }
        },
        clearMarkers() {
            this.setMapOnAll(null);
        },
        mapViegetLocation() {
            this.currentLoc = JSON.parse(localStorage.getItem("currentLoc"));
            this.locationAdd = localStorage.getItem("Autocomplete");

            var pos = {
                lat: this.currentLoc.latitude,
                lng: this.currentLoc.longitude
            };

            this.map.setCenter(pos);
            this.map.setZoom(this.configData.googleMapZoomLevel);

            this.filterCall();
        },
        bookNow() {
            localStorage.setItem("teleUrl", this.teleUrl)
            localStorage.setItem("selectedMarker", JSON.stringify(this.selectedMarker))
            localStorage.setItem("opensAt", this.opensAt)
            localStorage.setItem("closesAt", this.closesAt)
            this.$router.push({ name: "carterBookNow" });
        },
    }
})
</script>


<style scoped>
.qrcodeStream {
width: 50%;
height: 30%;
margin: 0 auto;
border: 5px solid #21b24b;
/* border-right: 5px solid #21b24b; */
border-radius: 5px;
margin-bottom: 90%;
}
.chargeNowFab {
    --background: #21b24b;
    /* --background: #21b24b; */
}
.qr-svg {
    width: 30px;
    color: rgb(250, 249, 249);
    /* font-weight: bolder; */
}
#pac-input:focus,
.res-content-wrapper .loc-search input:focus{
    padding: 12px;
    margin: 0;
}
    #res-map {
        height: 94%;
        width: 100%;
    }
.map-overlay{
    background: #000000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.3;
}
.spinnerWrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%)
}
.map-wrapper {
    height: 100%;
    width: 100%;
}

.card-list-wrapper {
    position: absolute;
}

.res-content-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10;
    padding: 16px;
}

.card-list-content p.title {
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #313131;
    opacity: 1;
    margin-bottom: 8px;
}

.card-list-content p.time {
    font-family: 'Roboto Light';
}

.card-list-content p.loc,
.card-list-content p.time {
    text-align: left;
    margin-bottom: 8px;
    font-size: 15px;
    letter-spacing: 0;
    color: #313131;
    opacity: 0.75;
}

.card-list-booking p {
    height: 17px;
    text-align: right;
    margin-right: 8px;
    font-size: 14px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #D66C6C;
    opacity: 1;
}

.card-list-booking {
    text-align: right;
}
.iocl-div-img {
    text-align: right;
}
.iocl_img {
    margin-top: -1rem;
    width: 300px;
    /* height: 15%; */
}
.call-options .book-btn {
    width: 115px;
    --background: #21b24b !important;
    border-radius: 36px;
    /* opacity: 1; */
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #FFFFFF;
    display: inline-block;
    position: relative;
    top: -15px;
}

.call-options {
    margin-top: 16px;
}

.call-options img.call-img {
    width: 24px;
    height: 24px;
    position: relative;
    top: -3px;
}

.call-options a.call-img-a {
    margin-right: 21px;
}

.call-options img.map-img {
    width: 36px;
    height: 36px;
    margin-right: 29px;
    cursor: pointer;
}

.card-list-content p.loc {
    font-family: 'Roboto';
}

.card-list-wrapper {
    bottom: 100px;
    width: 100%;
    padding: 0 30px;

}

@media (max-width: 768px) {
    .card-list-wrapper {
        padding: 0 14px;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
}

.card-list {
    height: 100px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 16px;
    opacity: 1;
    padding: 16px;
}

@media (max-width: 768px) {
    .card-list {
        height: 185px;
    }

    .card-list-booking {
        text-align: left !important;
        position: absolute;
        width: 100%;
        top: -36px;
    }

    .call-options .book-btn {
        position: absolute;
        top: 27px;
        right: 0px;
    }

    .card-list-booking p {
        position: relative;
        top: 6px;
    }

    .res-content-wrapper {
        padding: 0px !important;
    }
}

/* SearchBox */

.res-content-wrapper.listView .loc-search {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #D6D6D6;
    background: #F4F5F9;
}

.res-content-wrapper.listView {
    background: #F4F5F9;
}

.res-content-wrapper .loc-search input {
    height: 52px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #0000001A;
    border-radius: 12px;
    opacity: 1;
    width: 100%;
    padding: 12px;
    padding-left: 98px !important;
    font-size: 14px;
    text-align: left;
    padding-left: 24px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #9e9d9d;
}

.res-content-wrapper .loc-search img.map-marker-icon {
    width: 18px;
    height: 18px;
    opacity: 1;
    cursor: pointer;
}

.loc-wrpaper span {
    height: 17px;
    text-align: left;
    font-size: 14px;
    position: absolute;
    font-family: 'Roboto';
    letter-spacing: 0;
    top: 18px;
    padding-left: 18px;
    color: #404040;
    opacity: 1;

}

.loc-wrpaper img,
.loc-wrpaper span {
    z-index: 99;
}

.loc-wrpaper {
    position: relative;
}

.loc-wrpaper img.map-marker-icon {
    position: absolute;
    right: 12px;
    top: 17px;
    cursor: pointer;
}

@media (max-width: 768px) {
    .lense-icon{
        position: absolute;
    }
    .res-content-wrapper .loc-search input {
        padding-left: 50px !important;
        text-overflow: ellipsis;
        padding-right: 56px;
    }

    .res-content-wrapper .loc-search {
        padding: 9px;
    }
}
</style>
